/**
 * Da formato a un error de la API del backend como texto para mostrar.
 * Trata errores de validación FastAPI / Pydantic (array de {type, loc, msg, ...})
 * y errores en cadena simple.
 */
export function formatApiError(err, fallback = 'Error') {
  if (!err) return fallback;

  // Error de red (sin respuesta)
  if (!err.response) return 'Error de conexión. Inténtalo de nuevo.';

  const detail = err.response?.data?.detail;
  if (!detail) return fallback;

  // Error en cadena simple
  if (typeof detail === 'string') return detail;

  // Array de errores de validación Pydantic: [{type, loc, msg, input, url}, ...]
  if (Array.isArray(detail)) {
    return detail
      .map(e => {
        if (typeof e === 'string') return e;
        if (e?.msg) return e.msg;
        return JSON.stringify(e);
      })
      .join(' | ');
  }

  // Objeto con campo msg
  if (typeof detail === 'object' && detail.msg) return detail.msg;

  return String(detail);
}
